import { PredefinedAlerts } from "@station/domain/models/predefined-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class CreatedPredefinedAlertGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(stationId: string): Promise<PredefinedAlerts> {
        const createdPredefinedAlertResult =
            await this.alertRepository.getAllCreatedPredefinedAlert(stationId);

        return createdPredefinedAlertResult.match(
            (createdPredefinedAlerts) => createdPredefinedAlerts,
            () => PredefinedAlerts.empty(),
        );
    }
}
